import React from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { goTo } from "../tools";
import { callService } from "../tools";
import "./mi-perfil.css";
import ConfirmaContraseniaFrm from "./confirmaContrasenia.frm";
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';
import { cierraSesionAppLogin } from "../app-database";

const mapState = (state) => {
    return {
        password: state.miPerfil.password,
        opcion: state.miPerfil.opcion,
        razon: state.miPerfil.razon,
        loader: state.global.loader
    };
}

const mapDispatch = (dispatch) => {
    return {
        cambiarPreguntas: (datos) => {
            dispatch(cambiarPreguntas(datos));
        },
        guardarPassword: (pass) => {
            dispatch({ "type": "MI_PERFIL_GUARDAR_PASSWORD", "password": pass });
        },
        loader: (show) => {
            dispatch({ "type": "LOADER", "show": show });
        },
    }
}

const validacion = "VALIDACIÓN";
const msjErrorTooltip = "Lo sentimos ocurrio un error, intentelo de nuevo.";

class ConfirmaContrasenia extends React.Component {

    state = {
        showTooltip: false,
        type: "",
        mensaje: "",
        titulo: "",
    }

    muestraTooltip = (show, type?, titulo?, mensaje?) => {
        setTimeout(() => {
            this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
        }, 300);
    }

    cierraTooltip = e => {
        this.setState({
            showTooltip: !this.state.showTooltip
        });
    }

    submit = () => {
        this.props.loader(true);
        const correo = localStorage.getItem("correoG");
        let cveClienteUnico = "";
        new callService({
            service: "registro.incConsultaRegistro",
            secure: true,
            data: {
                correo: correo.toLowerCase()
            }
        }).execute().then((respuesta) => {
            new callService({
                service: "registro.incConsultaDatosReg",
                secure: true,
                data: {
                    uid: respuesta.path
                }
            }).execute().then((datos) => {
                cveClienteUnico = datos.cveClienteUnico;
                const body = {
                    uid: datos.cveClienteUnico,
                    opt: this.props.opcion,
                    comentario: this.props.razon
                }
                new callService({
                    service: "registro.eliminarCuenta",
                    secure: true,
                    data: body
                }).execute().then((datosF) => {
                    console.log("***** datosF", datosF);
                }).catch((error) => {
                    if (error.status === 200) {
                        localStorage.setItem("cuentaEliminada", "true");
                        if (this.props.password !== "") {
                            const strJson = {
                                pass: this.props.password,
                                p1: "PSC15",
                                r1: "negro",
                                p2: "PSC04",
                                r2: "nissan",
                            };
                            new callService({
                                service: "miPerfil.actualizarPreguntas",
                                secure: true,
                                data: strJson,
                            }).execute()
                                .then((body) => {
                                    this.submit2(body, cveClienteUnico);
                                })
                                .catch((errorAc) => {
                                    this.props.loader(false);
                                    this.muestraTooltip(true, 'error', validacion, "Lo sentimos, ocurrio un error.");
                                    console.log("error", errorAc);
                                });
                        }
                    }
                });
            }).catch((errorR) => {
                console.log("Error consultar datos de la rama registro", errorR);
            });
        }).catch((errorCon) => {
            console.log("Error consultar datos de la rama concluir", errorCon);
        });

    }

    submit2 = (body, cveClienteUnico) => {
        const body2 = body;
        new callService({
            service: "registro.obtenerurlregistro",
            secure: false,
            data: { valor: cveClienteUnico }
        }).execute().then(resp => {
            if (body2.actualizarPreguntasClienteResponse.banExito === true) {
                new callService({
                    service: "miPerfil.cancelarCuenta",
                    secure: true,
                    data: {
                        clienteUnico: resp.hash,
                    },
                })
                .execute()
                .then((bodyC) => {
                    this.props.loader(false);
                    this.cerrarSesion();
                })
                .catch((errorC) => {
                    console.log("error cancelar", errorC);
                    this.muestraTooltip(true, 'error', validacion, msjErrorTooltip);
                });
            }
        }).catch(error => {
            console.log("error al encriptar el valor correo", error);
        });
    }

    cerrarSesion = () => {
        cierraSesionAppLogin();
    }

    render() {
        return (
            <div>
                <ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
                    show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
                </ModalSintillo>
                <ConfirmaContraseniaFrm onSubmit={this.submit} />
            </div>
        );
    }
}

ConfirmaContrasenia = reduxForm({ form: "contrasenia" })(ConfirmaContrasenia);
export default connect(mapState, mapDispatch)(ConfirmaContrasenia);


// WEBPACK FOOTER //
// ./src/miPerfil/confirmaContrasenia.cmpt.js